/**
 * Closed/signing-date selection for the sales dashboard (VIB-1092, F0.1).
 *
 * The "closed date" of a project is when the deal was won. Source of truth is
 * the linked offer's `offers.accepted_at` (guaranteed populated by the
 * set_offer_accepted_at trigger, see migration). Projects with no linked offer
 * fall back to `projects.created_at`.
 *
 * Internal projects (is_internal) are not sales and must be excluded from all
 * sales/pipeline aggregates — use isSalesProject() to filter before summing.
 *
 * Pure — no Supabase/React imports.
 */

export interface ClosedDateProject {
  id: string;
  created_at: string;
  is_internal: boolean | null;
}

/**
 * The date a project's deal was closed.
 * @param offerAcceptedAt the linked offer's accepted_at, or null/undefined if
 *   the project has no linked offer.
 * @returns offerAcceptedAt when present, else the project's created_at.
 */
export function pickClosedDate(
  project: ClosedDateProject,
  offerAcceptedAt?: string | null,
): string {
  return offerAcceptedAt ?? project.created_at;
}

/** True when a project counts as a sale (i.e. not an internal project). */
export function isSalesProject(project: { is_internal: boolean | null }): boolean {
  return project.is_internal !== true;
}
